module.exports = __webpack_public_path__ + "static/img/beta_bg_13.0eacce62.svg";